import { i18n } from "../services/i18nService";
import {
  getGlobalButtonFocusPath,
  getConfigForModalWithCloseButton,
  getGlobalButtonInfo
} from "../errors/globalButtons";
import { getAppState } from "../state";
import { findFromBrands } from "../helpers/find";
import {
  CHAMPIONS_TROPHY,
  CRICLIFE,
  getBuyBrandsInfoObjChampionsTrophy,
  getIsAnyChildOfParentActive,
  isBaseContent
} from "./tvodUtils";
import { convertToTitleCase, EPG_MODAL_TYPES } from "./epgUtil";
import { getBuyBrandsInfoObj, getBrandsName, redirectToBuyBrandsPage } from "./tvodUtils.js";
import PriceComponent from "../components/ModalSettings/PriceComponent";
import React from "react";
import { redirectTo } from "../services/navigationService";
import { routes } from "../routes";
import { historyMethods } from "../utils/historyMethods";
import { isSubscriptionActive } from "../utils/subscriptionExtendUtils.js";
import { checkIsNonChangeableMop } from "../services/billingService";

const STARZ = "starz";
const STARZPLAY = "starzplay";
export const CREDIT_CARD = "CREDIT_CARD";
export const DEFAULT = "DEFAULT";
const DISCLAIMER_LOGO = "/images/info-2.svg";

export function isChampionsTrophyAddOn(name) {
  // Add Criclife check for business requirements
  // return name === CHAMPIONS_TROPHY;
  return isChampionsTrophyFlow() ? name === CHAMPIONS_TROPHY || name === CRICLIFE : false;
}

export function isChampionsTrophyFlow() {
  const addOnsList = getAppState().subscriptions?.filter(data => data?.name === CHAMPIONS_TROPHY) || [];
  if (addOnsList?.length > 0) {
    return isUserSubscribedToChannel(getAppState().addons, CHAMPIONS_TROPHY) ? false : true;
  }
  return false;
}

export function showChannelSubscriptionErrorPopup(closeModal) {
  const { stateActions, setFocus } = this.props;
  stateActions.showGlobalModal(
    getConfigForModalWithCloseButton(
      {
        text: i18n.get("global.errors.account.channelError")
      },
      closeModal
    )
  );
  setFocus(getGlobalButtonFocusPath("close"));
  return false;
}

export function isAddonContent(name) {
  return name && name !== STARZ && name !== STARZPLAY;
}

export function isMainPackageAddOn(addOnName) {
  return getAddOnByName(addOnName)?.configuration?.isMainPackage || false;
}

export function isStandAloneAddon(addOnName) {
  return getAddOnByName(addOnName)?.configuration?.isStandalone || false;
}

export function getAddOnByName(addOnName) {
  const addOnsList = getAppState().subscriptions?.filter(data => data?.name === addOnName) || [];
  if (addOnsList?.length > 0) {
    return addOnsList[0];
  }
  return null;
}

export function getBrandName(isBrand) {
  if (!isBrand) return "";
  const names = window.location.pathname.split("/");
  return names[2];
}

export function getBrandLogoUrl(brandName, subscriptions) {
  let subscription = findFromBrands(brandName, subscriptions || []);
  let baseSubscription = findFromBrands(brandName, subscription?.brands);
  return subscription?.displayName === STARZPLAY
    ? baseSubscription?.configuration.logoDefaultPNG
    : subscription?.configuration.logoDefaultPNG;
}

export function isStarzPlaySubscription(brandName, subscriptions) {
  let subscription = findFromBrands(brandName, subscriptions || []);
  return subscription?.displayName === STARZPLAY;
}

export function getPaymentPlanOfSubscription(subscription) {
  const mop =
    subscription && subscription.paymentMethods.find(paymentMethod => paymentMethod.paymentType === CREDIT_CARD);
  const paymentPlans = (mop && mop.paymentPlans) || [];
  const paymentPlan = getHighestPaymentPlan(paymentPlans);
  return paymentPlan;
}

export function getHighestPaymentPlan(paymentPlans) {
  let highestPaymentPlan = null;
  paymentPlans.forEach(plan => {
    if (!highestPaymentPlan) {
      highestPaymentPlan = plan;
    } else if (highestPaymentPlan && plan.grossAmount > highestPaymentPlan.grossAmount) {
      highestPaymentPlan = plan;
    }
  });
  return highestPaymentPlan;
}

export function getPaymentPlans(subscription) {
  const mop =
    subscription && subscription.paymentMethods.find(paymentMethod => paymentMethod.paymentType === CREDIT_CARD);
  const paymentPlans = (mop && mop.paymentPlans) || [];
  return paymentPlans;
}

export function isUserSubscribedToChannel(addons = [], name, titleSubscriptionsArr = []) {
  if (isBaseContent(name) && getAppState().userAccountStatus?.toLowerCase() === "active") {
    return name;
  } else {
    const isContentActive = addons.find(addon => addon.name === name && addon.status.toLowerCase() === "active");
    if (isContentActive) {
      return isContentActive.name;
    }

    // check multi-tagging now
    if (titleSubscriptionsArr && titleSubscriptionsArr.length > 0) {
      let foundAddon = undefined;
      for (let index = 0; index < titleSubscriptionsArr.length; index++) {
        const subscription = titleSubscriptionsArr[index];
        if (isBaseContent(subscription) && getAppState().userAccountStatus?.toLowerCase() === "active") {
          foundAddon = subscription;
          break;
        } else {
          foundAddon = addons.find(
            addon => addon.name.toLowerCase() === subscription.toLowerCase() && addon.status.toLowerCase() === "active"
          );
          if (foundAddon) {
            break;
          }
        }
      }
      return foundAddon;
    } else {
      return isContentActive;
    }
  }
}

export function getSubscriptionNameForModal(addOnData) {
  const {
    applicationState: { country }
  } = this.props;
  const { subscriptionPerCountry, subscription } = addOnData || {};
  let subscriptionName = null;

  if (subscriptionPerCountry) {
    subscriptionName = subscriptionPerCountry[country.toUpperCase()]
      ? subscriptionPerCountry[country.toUpperCase()]
      : subscriptionPerCountry[DEFAULT];
  } else {
    subscriptionName = subscription && subscription.length > 0 ? subscription[0] : null;
  }
  return subscriptionName;
}

export function goToBuyBrandsPage(
  addonContent,
  childAddon = null,
  isChampionsTrophyAddOn = false,
  isCTStandalone = false,
  CTlogoImage = "",
  nextPage = "",
  backDestination = ""
) {
  redirectToBuyBrandsPage.call(this, {
    addonContent,
    childAddon,
    isChampionsTrophyAddOn,
    isCTStandalone,
    CTlogoImage,
    nextPage,
    backDestination
  });
}

export function getInActiveSubscriptionDisplayName(addonName) {
  const {
    applicationState: { addons }
  } = this.props;
  let action = "activate";
  let subscriptionName = getSubscriptionNameForModal.call(this, addonName);
  let subscription = getBrandsName(addons, subscriptionName);
  if (isChampionsTrophyAddOn(subscriptionName)) {
    const isParentActive = isUserSubscribedToChannel(addons, subscription?.name);
    let isAnyChildOfParentActive = !isParentActive ? getIsAnyChildOfParentActive(subscription, addons) : false;
    action = isAnyChildOfParentActive ? "upgrade" : "activate";
  }
  if (subscription) {
    const subscriptionStatus = isSubscriptionActive(addons, subscription.name);
    subscription =
      subscriptionStatus?.status?.toLowerCase() === "active"
        ? getAddOnByName(subscriptionName)
        : getBrandsName(addons, subscriptionName);
  }
  return {
    displayName: subscription?.displayName,
    action
  };
}

export async function showSubscriptionModal(
  addonName,
  isBrand,
  onClickBack = null,
  referrerPath = null,
  isChampionsTrophyAddOn = false
) {
  if (isChampionsTrophyAddOn) {
    return showSubscriptionModalChampionsTrophy.call(
      this,
      addonName,
      isBrand,
      onClickBack,
      referrerPath,
      isChampionsTrophyAddOn
    );
  } else {
    const {
      applicationState: { addons, userLogged },
      stateActions
    } = this.props;

    let isSwitchPlan = false,
      selectedSubscriptionLogo;
    let subscriptionName = isBrand ? addonName : getSubscriptionNameForModal.call(this, addonName);

    const infoObj = getBuyBrandsInfoObj(addons, subscriptionName);

    if (infoObj.buttonDisplayName !== "activate" && infoObj.buttonDisplayName !== "subscribe") {
      const userAddonsPlusMOP = await checkIsNonChangeableMop.call(this, true, infoObj.subscriptionName);
      infoObj["isCreditcardMOP"] = userAddonsPlusMOP.paymentType === "CREDIT_CARD" ? true : false;
      infoObj["deactivationAllowed"] = userAddonsPlusMOP?.configuration?.deactivationAllowed;
      infoObj["paymentMethodDisplayName"] = userAddonsPlusMOP?.displayName;
      const selectedAddon = getAddOnByName(addonName);
      infoObj["selectedAddonDisplayName"] = selectedAddon?.displayName;
      isSwitchPlan = true;
    }
    const subscription = getBrandsName(addons, infoObj.subscriptionName);
    let subscriptionLogo = subscription?.configuration.logoDefaultPNG;
    const championsTrophyData = infoObj?.CTAddOnData;

    const logosKeyName = `logosdisplaywhite_${subscription?.name}`;
    let childLogos = subscription?.configuration[logosKeyName] || [];
    childLogos = childLogos.length > 0 ? childLogos.split(",") : [];

    if (infoObj && infoObj.buttonDisplayName !== "activate" && infoObj.buttonDisplayName !== "subscribe") {
      selectedSubscriptionLogo = infoObj?.logoImage;
      const slicedSubscriptionName = subscriptionName.substring(0, 5);
      childLogos = childLogos.filter(url => !url.includes(slicedSubscriptionName));
      childLogos = childLogos.slice(0, 5);
    }
    let header =
      infoObj.buttonDisplayName === "activate" || infoObj.buttonDisplayName === "subscribe"
        ? subscription?.configuration["activationHeader" + convertToTitleCase(i18n.getLocale())]
        : i18n.get(
            `pages.brands.inActiveSubscriptions.switchOverlay.header`,
            infoObj.subscriptionDisplayName,
            infoObj.paymentPlanName
          );

    let title =
      infoObj.buttonDisplayName === "activate" || infoObj.buttonDisplayName === "subscribe"
        ? subscription?.configuration["activationSubHeader" + convertToTitleCase(i18n.getLocale())]
        : i18n.get(`pages.brands.inActiveSubscriptions.switchOverlay.title`, infoObj["selectedAddonDisplayName"]);

    if (infoObj && infoObj?.CTAddOnData?.isCTStandalone) {
      childLogos = [];
      subscriptionLogo = infoObj?.logoImage;
      header = championsTrophyData?.configuration["activationHeader" + convertToTitleCase(i18n.getLocale())];
      title = championsTrophyData?.configuration["activationSubHeader" + convertToTitleCase(i18n.getLocale())];
    }
    childLogos.length = childLogos.length > 15 ? 15 : childLogos.length;

    const subTitle =
      infoObj.buttonDisplayName === "activate" || infoObj.buttonDisplayName === "subscribe"
        ? ``
        : i18n.get(`pages.brands.inActiveSubscriptions.switchOverlay.subTitle`);
    const disclaimer1 =
      infoObj.buttonDisplayName === "activate" || infoObj.buttonDisplayName === "subscribe"
        ? ``
        : infoObj?.isCreditcardMOP
        ? i18n.get(`pages.brands.inActiveSubscriptions.switchOverlay.disclaimer.cc.title`)
        : infoObj?.deactivationAllowed
        ? i18n.get(`pages.brands.inActiveSubscriptions.switchOverlay.disclaimer.managed.title`)
        : i18n.get(`pages.brands.inActiveSubscriptions.switchOverlay.disclaimer.nonManaged.title`);

    const disclaimer2 =
      infoObj.buttonDisplayName === "activate" || infoObj.buttonDisplayName === "subscribe"
        ? ``
        : infoObj?.isCreditcardMOP
        ? i18n.get(`pages.brands.inActiveSubscriptions.switchOverlay.disclaimer.cc.desc`, infoObj.subscriptionName)
        : infoObj?.deactivationAllowed
        ? i18n.get(`pages.brands.inActiveSubscriptions.switchOverlay.disclaimer.managed.desc`)
        : i18n.get(
            `pages.brands.inActiveSubscriptions.switchOverlay.disclaimer.nonManaged.desc`,
            infoObj?.subscriptionName,
            infoObj?.paymentMethodDisplayName
          );

    const buyBrandSubscription =
      isSwitchPlan && isBrand ? addonName : isSwitchPlan ? addonName.subscription[0] : subscription?.name;
    const childBrandSubscription = isBrand && infoObj?.enforceAnnualPlanForCricketHome ? addonName : null;

    stateActions.showGlobalModal({
      modalTitle: header,
      modalText: title,
      disclaimer1: disclaimer1,
      disclaimer2: disclaimer2,
      subTitle: subTitle,
      isSwitchPlan: isSwitchPlan,
      selectedSubscriptionLogo: selectedSubscriptionLogo,
      type: EPG_MODAL_TYPES.VERTICAL_SIDEBAR_SUBSCRIPTION_POPUP,
      subscriptionLogo,
      priceComponent: <PriceComponent infoObj={infoObj} />,
      subscriptionLogoChildLogosList: childLogos,
      buttons: [
        {
          ...getGlobalButtonInfo(isSwitchPlan ? "switch" : "continue"),
          buttonHandler: !userLogged
            ? () =>
                redirectTo.call(
                  this,
                  routes.pinSignup,
                  {
                    ...{ nextPage: referrerPath || routes.live },
                    ...{ backDestination: referrerPath || routes.live }
                  },
                  historyMethods.REPLACE
                )
            : () =>
                goToBuyBrandsPage.call(
                  this,
                  infoObj?.CTAddOnData?.isCTStandalone ? infoObj?.CTAddOnData?.name : buyBrandSubscription,
                  childBrandSubscription,
                  isChampionsTrophyAddOn,
                  infoObj?.CTAddOnData?.isCTStandalone,
                  infoObj?.logoImage,
                  "",
                  referrerPath
                )
        }
      ],
      loggedInButton: [
        !userLogged && {
          ...getGlobalButtonInfo("login"),
          buttonHandler: () =>
            redirectTo.call(
              this,
              routes.pin,
              {
                ...{ nextPage: referrerPath || routes.live },
                ...{ backDestination: referrerPath || routes.live }
              },
              historyMethods.REPLACE
            )
        }
      ],
      onClickBack: onClickBack
    });

    this.setFocusAfterModalOpen(getGlobalButtonFocusPath("continue"));
    return subscription?.displayName;
  }
}

async function showSubscriptionModalChampionsTrophy(
  addonName,
  isBrand,
  onClickBack = null,
  referrerPath = null,
  isChampionsTrophyAddOn = false
) {
  const {
    applicationState: { addons, userLogged },
    stateActions
  } = this.props;

  let subscriptionName = isBrand ? addonName : getSubscriptionNameForModal.call(this, addonName);

  const infoObj = getBuyBrandsInfoObjChampionsTrophy(addons, subscriptionName);

  const subscription = getBrandsName(addons, infoObj.subscriptionName);
  let subscriptionLogo = subscription?.configuration.logoDefaultPNG;
  const championsTrophyData = infoObj?.CTAddOnData;
  const paymentPlan = subscription?.paymentMethods[0]?.paymentPlans[0]?.planName;
  const monthlyPlanCopy = subscription?.paymentMethods[0]?.configuration[
    `${paymentPlan}_display_name_short_${i18n.getLocale()}`
  ]?.toLowerCase();
  const yearlyPlanCopy = subscription?.paymentMethods[0]?.configuration[
    `${subscription?.paymentMethods[0]?.name}_12_months_display_name_short_${i18n.getLocale()}`
  ]?.toLowerCase();
  const logosKeyName = `logosdisplaywhite_${subscription?.name}`;
  let childLogos = subscription?.configuration[logosKeyName] || [];
  childLogos = childLogos.length > 0 ? childLogos.split(",") : [];

  let header = subscription?.configuration["activationHeader" + convertToTitleCase(i18n.getLocale())];

  let title = subscription?.configuration["activationSubHeader" + convertToTitleCase(i18n.getLocale())];

  if (infoObj && infoObj?.CTAddOnData?.isCTStandalone) {
    childLogos = [];
    subscriptionLogo = infoObj?.logoImage;
    header = championsTrophyData?.configuration["activationHeader" + convertToTitleCase(i18n.getLocale())];
    title = championsTrophyData?.configuration["activationSubHeader" + convertToTitleCase(i18n.getLocale())];
  } else if (infoObj && isChampionsTrophyAddOn) {
    childLogos = childLogos.slice(0, 5);
  }
  childLogos.length = childLogos.length > 15 ? 15 : childLogos.length;

  // #FIXME: clean up this code after ICC-CT release
  const isSwitchPlan = false;
  const buyBrandSubscription =
    isSwitchPlan && isBrand ? addonName : isSwitchPlan ? addonName.subscription[0] : subscription?.name;

  let seasonPassData = null,
    upgradeDisclaimer = "";
  if (infoObj?.isShowUpgradeDisclaimer) {
    upgradeDisclaimer = {
      logo: DISCLAIMER_LOGO,
      text: i18n.get(
        "pages.brands.inActiveSubscriptions.seasonPass.disclaimerText",
        infoObj?.subscriptionDisplayName,
        infoObj?.paymentPlan.packageTimeUnit
      )
    };
  }

  if (infoObj?.CTAddOnData && infoObj.CTAddOnData.CTPrices) {
    let championsTrophyCopy = "";
    if (infoObj.CTAddOnData.CTPrices.monthlyPrice === 0 && infoObj.CTAddOnData.CTPrices.annualPrice === 0) {
      championsTrophyCopy = i18n.get(
        "pages.brands.inActiveSubscriptions.seasonPass.freeText",
        monthlyPlanCopy,
        yearlyPlanCopy
      );
    } else {
      championsTrophyCopy = i18n.get(
        `pages.brands.inActiveSubscriptions.seasonPass.price`,
        infoObj?.CTAddOnData.CTPrices.monthlyPrice === 0
          ? i18n.get("global.free")
          : infoObj?.CTAddOnData.CTPrices.monthlyPrice,
        monthlyPlanCopy,
        infoObj?.CTAddOnData.CTPrices.annualPrice === 0
          ? i18n.get("global.free")
          : infoObj?.CTAddOnData.CTPrices.annualPrice,
        yearlyPlanCopy
      );
    }
    seasonPassData = {
      logo: championsTrophyData?.configuration[`logoCircularPNG_${i18n.getLocale()}`],
      heading: i18n.get("pages.brands.inActiveSubscriptions.seasonPass.heading", championsTrophyData?.displayName),
      price: championsTrophyCopy
    };
  }

  stateActions.showGlobalModal({
    modalTitle: header,
    modalText: title,
    type: EPG_MODAL_TYPES.VERTICAL_SIDEBAR_SUBSCRIPTION_POPUP,
    subscriptionLogo,
    priceComponent: <PriceComponent infoObj={infoObj} />,
    subscriptionLogoChildLogosList: childLogos,
    seasonPassData,
    upgradeDisclaimer,
    buttons: [
      {
        ...getGlobalButtonInfo("continue"),
        buttonHandler: !userLogged
          ? () =>
              redirectTo.call(
                this,
                routes.pinSignup,
                {
                  ...{ nextPage: referrerPath || routes.live },
                  ...{ backDestination: referrerPath || routes.live }
                },
                historyMethods.REPLACE
              )
          : () =>
              goToBuyBrandsPage.call(
                this,
                infoObj?.CTAddOnData?.isCTStandalone ? infoObj?.CTAddOnData?.name : buyBrandSubscription,
                null,
                isChampionsTrophyAddOn,
                infoObj?.CTAddOnData?.isCTStandalone,
                infoObj?.logoImage
              )
      }
    ],
    loggedInButton: [
      !userLogged && {
        ...getGlobalButtonInfo("login"),
        buttonHandler: () =>
          redirectTo.call(
            this,
            routes.pin,
            {
              ...{ nextPage: referrerPath || routes.live },
              ...{ backDestination: referrerPath || routes.live }
            },
            historyMethods.REPLACE
          )
      }
    ],
    onClickBack: onClickBack
  });

  this.setFocusAfterModalOpen(getGlobalButtonFocusPath("continue"));
  return subscription?.displayName;
}

export function isAnyAddonStatusActive(addons) {
  if (addons) {
    for (const addon of addons) {
      if (addon?.status?.toLowerCase() === "active") {
        return true;
      }
    }
  }

  return false;
}
